import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import Slide from '@mui/material/Slide';
import {
	Box,
	Button,
	DialogActions,
	List,
	ListItemButton,
	ListItemText,
	ListSubheader,
} from '@mui/material';
import { useState, useEffect } from 'react';
import { getSubBiases } from '../../../actions/biases';
import { sortSizes } from '../../../helpers/utils';

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction='up' ref={ref} {...props} />;
});

export const BiasSizesDialog = ({
	open,
	handleClose,
	bias = null,
	sizes = null,
}) => {
	const [subbiases, setSubbiases] = useState([]);

	useEffect(() => {
		if (bias && sizes === null) {
			getSubBiases(bias?.id, 'id').then(({ data }) => {
				const sizes = data.results.map((item) => ({
					key: item.key,
					size: item.size.name,
					units: item.units,
				}));
				setSubbiases(sortSizes(sizes, 'size'));
			});
		} else {
			setSubbiases(sizes);
		}
	}, [bias]);

	return (
		<Dialog
			maxWidth='sm'
			open={open}
			onClose={handleClose}
			TransitionComponent={Transition}
		>
			{/* Content */}
			<Box sx={{ flexGrow: 1 }}>
				<div style={{ padding: '20px' }}>
					{subbiases?.length > 0 ? (
						<List
							sx={{
								width: '100%',
								maxWidth: 360,
								bgcolor: 'background.paper',
							}}
							component='nav'
							aria-labelledby='nested-list-subheader'
							subheader={
								<ListSubheader
									component='div'
									id='nested-list-subheader'
								>
									<b>
										Tallas de la partida {bias?.key || ''}
									</b>
								</ListSubheader>
							}
						>
							{subbiases.map(
								({ key, size, units, percentage }, index) => (
									<ListItemButton key={`${index}-${key}`}>
										<ListItemText
											primary={
												key
													? key
													: `Talla: ${size} - Unidades: ${units}`
											}
											secondary={
												key
													? `Talla: ${size} - Unidades: ${units}`
													: `Incremento +${
															percentage * 100
													  }%`
											}
										/>
									</ListItemButton>
								)
							)}
						</List>
					) : (
						<h5>Esta partida no tiene tallas.</h5>
					)}
				</div>
			</Box>
			<DialogActions>
				<Button onClick={() => handleClose()}>Ok</Button>
			</DialogActions>
		</Dialog>
	);
};
